import { createContext } from 'react';
export var StickyCommentBoxContext = createContext(false);
//# sourceMappingURL=context.js.map